import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { amountToLong } from '../../utils/amountToLong';
import { paymentModalClosed } from '../../utils/bi/events/applePay';
import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';

type CancelHandlerParams = {
  biLogger: BiLogger;
  biData: {
    paymentAmount: string;
    currencyCode: string;
  };
};

/**
 * Handles cancel event
 */
export const cancelHandler =
  ({ biLogger, biData }: CancelHandlerParams) =>
  async () => {
    biLogger.report(
      paymentModalClosed({
        amount: amountToLong(biData.paymentAmount),
        currency: biData.currencyCode,
        checkoutType: 'express',
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
      }),
    );

    return Promise.resolve();
  };
